import React from 'react'
import { LoaderCircle } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ILoaderProps {
  className?: string
}

const Loader = ({ className }: ILoaderProps) => (
  <div className={cn('flex items-center justify-center min-h-screen', className)}>
    <LoaderCircle className="h-8 w-8 animate-spin text-primary" />
  </div>
)

export default Loader
